import { queryClient } from "@/lib/query-client";

/**
 * End the session and leave the signed-in tree.
 *
 * `fetch` rather than `api()`: the transport guard in lib/api/client.ts
 * refuses any path outside `/v1/`, and the auth routes deliberately sit
 * outside the versioned API because they are browser navigations rather than
 * API calls. Body-less POST, so no content-type is needed; the origin guard
 * reads `Sec-Fetch-Site`, which the browser sets and no page script can forge.
 *
 * The last step is a HARD navigation. A client-side route change leaves the
 * signed-in tree mounted, and every component still holding pre-logout data
 * keeps rendering it until something happens to re-render — which is how a
 * "signed out" screen ends up still showing a member list.
 */
export async function logout(): Promise<void> {
  // A transport failure here is not worth surfacing and must not abort the
  // rest: the cookie may already be gone server-side, and leaving someone
  // staring at a signed-in shell they cannot use is the worse outcome.
  await fetch("/auth/logout", { method: "POST" }).catch(() => undefined);

  // Clear, not invalidate. Invalidating refetches every query that is still
  // mounted, which fires a burst of now-401 requests on the way out.
  queryClient.clear();
  window.location.assign("/login");
}
